export default "__VITE_ASSET__C6EhrSL4__"